var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "blockchains"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Blockchains")]), [_c('div', {
    staticClass: "bar"
  }, [_c('p', {
    staticClass: "count"
  }, [_vm._v(" " + _vm._s(_vm.totalBlockchains.toLocaleString()) + " blockchains found ")])])]], 2), _vm.loading && !_vm.subnetsLoaded ? [_c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })] : [_c('BlockchainDataTable', {
    attrs: {
      "blockchains": _vm.blockchains,
      "links": true,
      "subnets": true
    }
  })]], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }